import { CommonModule, formatDate } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InteractionLogService } from 'src/app/services/interaction-log.service';

@Component({
  selector: 'app-logreport',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './logreport.component.html',
  styleUrl: './logreport.component.scss',
})
export class LogreportComponent implements OnInit {
  agentReports: any[] = [];
  fromDate: string = '';
  toDate: string = '';

  constructor(private interactionLogService: InteractionLogService) {}

  ngOnInit() {
    const today = new Date();

    const oneWeekBack = new Date(today);
    oneWeekBack.setDate(today.getDate() - 7);

    this.fromDate = formatDate(oneWeekBack, 'yyyy-MM-dd', 'en');
    this.toDate = formatDate(today, 'yyyy-MM-dd', 'en');

    this.fetchReport();
  }

  fetchReport() {
    this.interactionLogService
      .getAgentReportSummary(this.fromDate, this.toDate)
      .subscribe((data) => (this.agentReports = data));
  }

  getAllStatuses(): string[] {
    // Ideally fetched from backend or constant file
    return [
      'Order_Placed',
      'Deal_In_Progress',
      'Follow_Up_Required',
      'Deal_Rejected',
      'Not_Reachable',
      'Information_Shared',
      'No_Response',
    ];
  }
}
